
import React, { useEffect, useState } from "react";
import axios from 'axios';
import Loader from "../components/loader";
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import { getNBNApiHeader } from "utlis/commonfunctions";

const Plans = ({ vispID, getDefaultPlan, getCheckValidVisp, addressVerify, nbnSessionId, AvailablePlan,userToken }) => {

  const apiUrl = process.env.REACT_APP_API_URL;
  const apiKey = process.env.REACT_APP_API_TOKEN;
  const headers = getNBNApiHeader();

  const [plans, setPlans] = useState([]);
  const [defaultPlanId, setDefaultPlanID] = useState(null);
  const [resetPlan, setResetPlan] = useState(false); // Define resetPlan state variable and its setter
  const [index, setIndex] = useState(0);
  useEffect(() => {
    // Load plans when AvailablePlan changes
    if (AvailablePlan.length > 0) {
      loadPlans(AvailablePlan);
    } else {
      loadPlans([]);
    }

    // Handle address verification changes
    if (addressVerify !== resetPlan) {
      if (addressVerify === false) {
        loadPlans(AvailablePlan);
      }
      setResetPlan(addressVerify);
    }

  }, [AvailablePlan, addressVerify, resetPlan]); // Include resetPlan in dependency array

  const loadPlans = async (plans) => {
    const payload = {
      "plan_array": plans
    };

    try {
      const response = await axios.post(apiUrl + 'nbn/get-nbn-plans', payload, { headers: headers });
      if (response.status === 200) {
        const data = response.data.data;
        if (data && data.plans.length > 0) {
          const latestPlan = data.plans[data.plans.length - 1];
          setDefaultPlanID(latestPlan.plan_id);
          getDefaultPlan(latestPlan);
          setPlans(data.plans);

        }
      }
    } catch (error) {
      console.error("Error loading plans:", error);
    }
  };

  const formatNumber = (num) => {
    // Convert number to string
    let formattedNumber = num.toString();

    // Check if the number has decimal '.00' and remove it
    if (formattedNumber.includes('.00')) {
      formattedNumber = formattedNumber.replace('.00', '');
    }

    return formattedNumber;
  };

  const PlanSelectHandler = (plan, planId) => {
    setDefaultPlanID(planId);
    getDefaultPlan(plan);
  };

  const handleSelect = (selectedIndex) => {
    if (selectedIndex !== index) {
      setIndex(selectedIndex);
    };
  }


  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1440 }, // Larger screens, e.g., desktops and large laptops
      items: 4,
      slidesToSlide: 4 // optional, default to 1.
    },
    laptop: {
      breakpoint: { max: 1440, min: 1024 }, // Laptops, including MacBooks
      items: 3,
      slidesToSlide: 3 // optional, default to 1.
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 }, // Tablets and smaller laptops
      items: 2,
      slidesToSlide: 2 // optional, default to 1.
    },
    mobile: {
      breakpoint: { max: 464, min: 0 }, // Mobile phones
      items: 1,
      slidesToSlide: 1 // optional, default to 1.
    }
  };
  

  return (
    <div className="container" id="planSelectionBox">
      <section className="common-section">
        <div className="row">
          <div className="header-title">
            <h2 className="h3">2. Choose Telsim NBN<sup>&reg;</sup>  Home Internet Plans</h2>
            <p style={{ textAlign: "left" }}>Applicable plans for the customer's address are listed here.</p>
          </div>
          <Carousel
            swipeable={true}
            draggable={true}
            showDots={true}
            responsive={responsive}
            ssr={true}
            infinite={false}
            autoPlay={false}
            autoPlaySpeed={1000}
            keyBoardControl={true}
            customTransition="transform 0.5s ease-in-out"
            transitionDuration={500}
            containerClass="carousel-container"
            removeArrowOnDeviceType={["tablet", "mobile"]}
            deviceType={"desktop"}
            dotListClass="custom-dot-list-style"
            itemClass="carousel-item-padding-40-px"
          >
            {plans.map((plan, index) => (
              <div key={index} className="pricing-card discount-height"  id="planSelectionBox">
            
                 {plan.offer_amount== 0 ?     
                    <p class="custom-paragraph">Popular Plan</p>:""
                } 
           
                <div className="plan-bg">
                <img src={plan.plan_card_icon} alt="Plan Icon" className={`plan-icon ${plan.offer_amount == 0 ? 'popular-flag' : ''}`} />
                  {/* <h2> ${`${plan.rtap_sale_amount}`}<span style={{ fontSize: '1.5rem' }}></span> </h2> */}
              
                  {plan.offer_flag === 1 ? (
                    <>
                      <h2 className="strike-amount">
                        <span className={`strikethrough ${plan.offer_amount == 0 ? 'popular-strike' : ''}`}>${plan.rtap_sale_amount}</span>
              
                      </h2>
                      <h2>
                        ${plan.offer_amount}
                      </h2>
                      <p style={{ color: 'white', fontSize: '0.8rem' }}>
                        *First month only. Ongoing <br></br>${plan.rtap_sale_amount} monthly.
                      </p>
                    </>
                  ) : (
                    <>
                      <h2 className="discount-amount">${plan.rtap_sale_amount}</h2>
                      <h4>Monthly</h4>
                    </>
                  )}


                </div>
                <h5 style={{ marginTop: "10px" }}>NBN<sup>&reg;</sup> Home<br />{plan.website_plan_name.replace('NBN Home', '')}</h5>
                <h3>NBN<sup>&reg;</sup> <small>{plan.download_speed}/{plan.upload_speed} Mbps</small></h3>
                <p>Typical evening speed</p>
                <p>(7pm-11pm)</p>
                <center>
                  <table className="table table-borderless price-table">
                    <thead>
                      <tr>
                        <th valign="middle">{formatNumber(plan.typical_download_speed)} Mbps</th>
                        <th valign="middle">{formatNumber(plan.typical_upload_speed)} Mbps</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td valign="top">DOWNLOAD</td>
                        <td valign="top">UPLOAD</td>
                      </tr>
                    </tbody>
                  </table>
                </center>
                <br />
                <div className="data-pack">
                  <b>{plan.data === null ? plan.data_text : `${plan.data} GB`}</b>
                </div>

                <div className="data-pack-description">
                  <b>DESIGNED FOR</b>
                  <br />
                  <br />
                  <ul>
                    {plan.description.map((value, index) => (
                      <li key={index}><i className="fa fa-check-circle-o" aria-hidden="true"></i>{value}</li>
                    ))}
                  </ul>
                </div>
                <button className="button hovBtn custom-btn" style={{ width: '100%' }} onClick={() => PlanSelectHandler(plan, plan.plan_id)}>
                  <span className="text">{plan.plan_id === defaultPlanId ? "✓ SELECTED" : "SELECT"}</span>
                </button>

                <p style={{ marginTop: '10px' }}><a href="https://www.telsim.com.au/wp-content/uploads/2026/06/Telsim_CIS_NBN_Homeinternet_09062026.pdf" target="_blank" rel="noopener noreferrer">Critical Information Summary</a></p>
                <p style={{ marginTop: '10px' }}><a href="https://www.telsim.com.au/wp-content/uploads/2026/06/Telsim_NBN_Key_Facts_Sheet_09062026.pdf" target="_blank" rel="noopener noreferrer">Fact Sheet</a></p>
                {plan.offer_flag === 1 ?     
                <p style={{ marginTop: '10px' }}><a href= {plan.terms_and_condition_path}target="_blank" rel="noopener noreferrer">Terms & Conditions</a></p>
                    :"" }
             
              </div>
            ))}
          </Carousel>
        </div>
      </section>
    </div>
  );
};

export default Plans;
